import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MonitoringService } from 'src/app/services/monitoring.service';
import { CampaignModel } from 'src/app/models/campaigns.model';
import { ApexChart, ApexNonAxisChartSeries, ApexResponsive, ApexPlotOptions, ApexLegend, ApexStates, ApexAxisChartSeries, ApexXAxis  } from 'ng-apexcharts';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { BoxMaterialsListComponent } from '../shared/dialogs/box-materials-list/box-materials-list.component';
import { Overlay } from '@angular/cdk/overlay';

@Component({
  selector: 'app-monitoring',
  templateUrl: './monitoring.component.html',
  styleUrls: ['./monitoring.component.scss']
})
export class MonitoringComponent implements OnInit {

      mostrarTab = true;
      campaignSelected?: CampaignModel;
      campaignList = new Array<CampaignModel>();
      isLoading = true;
      isLoadingGeneral = true;
      isLoadingPeriodos = true;
      isLoadingCajas = true;
      isLoadingArchivo = true;
      isLoadingPaqueteria = true;
      isLoadingTamanos = true;
      isLoadingRecolecciones = true;
      isLoadingCajasProcesadas = true;
      isLoadingCumplimiento = true;
      isLoadingDefectos = true;
      isLoadingCajasRechazadas = true;
      isLoadingPicksStation = true;
      isLoadingRanking = true;
      isLoadingCalidad = true;

      compania = '';
      fecha_inicio =  '';
      fecha_fin = '';

      //Objetivo general
      total_cajas: number = 0;
      total_cajas_encintadas: number = 0;
      duracion_campana: number = 0;
      objetivo_diario: number = 0;
      hr_restantes = '';
      progress: number = 0;

      //Cards
      totalSKU: number = 0;
      bolsas: number = 0;
      zonas: number = 0;
      totalPicks: number = 0;
      materialG: number = 0;
      sucursales: number = 0;

      periodos:{nombre: string, inicio: string, fin: string, cajas: number}[] = [];

      //Progreso por cajas
      progresoxcajas: {box_id: number, zona: string, consecutivo:number, id_ext:number, in_line:number, taped:number, closed:number, status: string }[] = [];
      selectedCategory: string | null = null;

      pendientes: number = 0;
      en_linea: number = 0;
      cerradas: number = 0;
      encintadas: number = 0;

      chartSeries: ApexNonAxisChartSeries = [];
      chartLabels: string[] = ["Pendientes", "En línea", "Cerradas", "Encintadas"];
      chartColors: string[] = ["#fdcc10", "#f7941d", "#48b857", "#ef2f57"];
      
      chartDetails: ApexChart = {
        type: "donut",
        width: 380,
        events: {
          dataPointSelection: (event, chartContext, config) => {
            const index = config.dataPointIndex;
            const selectedCategory = this.chartLabels[index];
            this.filtrarTablaPorCaja(selectedCategory);
          }
        }
      };

      chartPlotOptions: ApexPlotOptions = {
        pie: {
          donut: {
            size: "45%",
            labels: {
              show: true,
              name: {
                show: false,
                fontSize: '16px',
              },
              value: {
                show: true,
                fontSize: '18px',
              },
              total: {
                show: true,
                label: "",
                color: '#000',
                formatter: (w) => {
                  return `${this.chartSeries.reduce((a, b) => a + b, 0)}`;
                }
              }
            }
          }
        }
      };

      chartLegend: ApexLegend = {
        position: "left",
        fontSize: "14px",
        labels: {
          colors: "#333"
        }
      };

      chartDataLabels = {
        enabled: true,
        formatter: (val: any, opts: any) => {
          return `${opts.w.config.series[opts.seriesIndex]}`;
        },
        style: {
          fontSize: '13px',
          fontFamily: 'Helvetica, Arial, sans-serif',
          colors: ["#000"]
        },
        dropShadow: {
          enabled: false
        }
      };

      chartResponsive: ApexResponsive[] = [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: "bottom"
            }
          }
        }
      ];

      chartStates: ApexStates = {
        hover: {
          filter: {
            type: 'opacity',
            value: 0.2
          }
        },
        active: {
          filter: {
            type: 'none'
          }
        }
      };
    
      @ViewChild("paginator") paginator!: MatPaginator;
      @ViewChild("sort") sort!: MatSort;
      dsCajas!: MatTableDataSource<any>;
      colsCajas: string[] = ['box_id', 'id_ext', 'consecutivo', 'zona', 'status', 'actions'];

      //Progreso por archivo
      progresoxarchivo: {nombre: string, file: string, consecutivos:string, paqueteria: string}[] = [];
      selectedCategoryArchivo: string | null = null;

      chartSeries2: ApexNonAxisChartSeries = [];
      chartLabels2: string[] = [];
      
      chartDetails2: ApexChart = {
        type: "pie",
        width: 380,
        events: {
          dataPointSelection: (event, chartContext, config) => {
            const index = config.dataPointIndex;
            const selectedCategoryArchivo = this.chartLabels2[index];
            this.filtrarTablaPorArchivo(selectedCategoryArchivo);
          }
        }
      };

      chartPlotOptions2: ApexPlotOptions = {
        pie: {
          donut: {
            size: "45%",
          }
        }
      };

      @ViewChild("paginatorArchivo") paginatorArchivo!: MatPaginator;
      @ViewChild("sortArchivo") sortArchivo!: MatSort;
      dsArchivo!: MatTableDataSource<any>;
      colsArchivo: string[] = ['paqueteria', 'archivo', 'estatus_linea', 'acciones'];

      //Progreso por paqueteria
      filterCarrier = false;
      selectedCarrier: string | null = null;
      progresoxpaqueteria=new Array<any>();
      validCarriers: string[] = ['99m', '99minutos', '99minutosmexico', '99minutosmx','afimex','bluexpress','blux','blx','bsm','buho','cch','chilexpress','chlex','chx','correoschile','dhl','dhlm','dhlmexico','est','estafeta','estafetamexico','estafetamx','estafetas','ests','fdx','fdxm','fedex','fedexmexico','hc gr','hcg','jtex','jtexpress','jtexpressmx','minicon_dhl','minicon_est','minicon_fdx','minicon_pex','mx99','mxpt','mxrp','paquetexpress','redpack','segmailmx','sgm','skn', 'stark','starken','ups'];

      @ViewChild("paginatorPaqueteria") paginatorPaqueteria!: MatPaginator;
      @ViewChild("sortPaqueteria") sortPaqueteria!: MatSort;
      dsPaqueteria!: MatTableDataSource<any>;
      colsPaqueteria: string[] = ['paqueteria', 'pendientes', 'en_linea', 'cerradas', 'encintadas'];

      @ViewChild("paginatorPaqueteriaFiltro") paginatorPaqueteriaFiltro!: MatPaginator;
      @ViewChild("sortPaqueteriaFiltro") sortPaqueteriaFiltro!: MatSort;
      dsPaqueteriaFiltro!: MatTableDataSource<any>;
      colsPaqueteriaFiltro: string[] = ['box_id', 'id_ext', 'consecutivo', 'zona', 'status', 'actions'];

      //Progreso por tamaños
      selectedTamano: string | null = null;
      progresoxtamanos=new Array<any>();
      tamanosDataTable: {box_id: number, zona: string, consecutivo: number, id_ext: string, in_line: number, taped: number, closed: number, box_size: string}[] = [];

      @ViewChild("paginatorTamanos") paginatorTamanos!: MatPaginator;
      @ViewChild("sortTamanos") sortTamanos!: MatSort;
      dsTamanos!: MatTableDataSource<any>;
      colsTamanos: string[] = ['box_id', 'id_ext', 'consecutivo', 'zona', 'status', 'actions'];

      //Recolecciones
      selectedRec1: string = 'cajas';
      selectedRec2: string = 'periodos';
      recCerradas: {nombrePeriodo: string, ultima_encintada: string, tipo: string, total_encintadas: number, fecha: string, color: string, fechaOriginal: string, dia: string, recolectadas: number, hora_recolectada: string, pendientes: string, hora_pendientes: string, documento: string}[] = [];
      objetivo_recolectadas: number  = 0;
      total_recolectadas_dia: number = 0;
      recCerradasTarde: {nombrePeriodo: string, ultima_encintada: string, tipo: string, total_encintadas: number, fecha: string, color: string, fechaOriginal: string, dia: string, recolectadas: number, hora_recolectada: string, pendientes: string, hora_pendientes: string, dias_retardo: number, documento: string}[] = [];
      arrayBoxIdsTotal = [];
      recPendientes: {nombrePeriodo: string, ultima_encintada: string, tipo: string, total_encintadas: number, fecha: string, color: string, fechaOriginal: string, dia: string, recolectadas: number, hora_recolectada: string, pendientes: string, hora_pendientes: string, documento: string}[] = [];

      colorsRecolecciones:any = {
        '1er periodo': { color:'#6f81ce'},
        '2do periodo': { color:'#d86c79'},
        '3er periodo': { color:'#fbb24d'},
        '4to periodo': { color:'#6f81ce'},
        '5to periodo': { color: '#d86c79'},
        '6to periodo': { color: '#fbb24d'}
      };

      //Picks por estacion
      @ViewChild("paginatorPicksEstacion") paginatorPicksEstacion!: MatPaginator;
      @ViewChild("sortPicksEstacion") sortPicksEstacion!: MatSort;
      dsPicksEstacion!: MatTableDataSource<any>;
      colsPicksEstacion: string[] = ['estacion', 'num_picks', 'totalSku', 'incorrects', 'objTiempoCaja', 'objTiempoPick', 'realTiempoCaja', 'realTiempoPick'];

      dataRealCaja: any[] = [];
      dataObjCaja: any[] = [];
      dataRealPick: any[] = [];
      dataObjPick: any[] = [];
      dataLabelsPicksCaja: any[] = [];

      barChartData: any = {labels: [], datasets: []}

      barChartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'bottom',
            labels: {
              font: {
                size: 12,
              },
              boxWidth: 12,
              padding: 8,
            },
            onHover: function (event:any) {
              event.native.target.style.cursor = 'pointer';
            },
            onLeave: function (event: any) {
              event.native.target.style.cursor = 'default';
            }
          },
          tooltip: {
            callbacks: {
              label: function(context: any) {
                const datasetLabel = context.dataset.label || '';
                const valueInMinutes = context.parsed.y;
                const totalSeconds = Math.round(valueInMinutes * 60);
                const minutes = Math.floor(totalSeconds / 60);
                const seconds = totalSeconds % 60;
                return `${datasetLabel}: ${minutes} m ${seconds} s`;
              }
            }
          }
        },
        scales: {
          x: {
            stacked: true
          },
          y: {
            stacked: true,
            min: 0, // valor mínimo
            max: 1, 
            ticks: {
              stepSize: 1,
              callback: function (value: any) {
                return `${value} min`;
              },
            },
            title: {
              display: true,
              text: 'Unidad: Tiempo'
            }
          }
        },
        
      };

      selectedRows: any[] = []; // Guarda hasta 2 objetos seleccionados
      selectedCajaPick: number = 1;

      //Progreso de calidad
      @ViewChild("paginatorCalidad") paginatorCalidad!: MatPaginator;
      @ViewChild("sortCalidad") sortCalidad!: MatSort;
      dsCalidad!: MatTableDataSource<any>;
      colsCalidad: string[] = ['usuario', 'num_calidad', 'totalBoxesByUser', 'num_picks', 'tiempo_real_cajas', 'tiempo_real_picks'];

      //Ranking de posiciones
      @ViewChild("paginatorRanking") paginatorRanking!: MatPaginator;
      @ViewChild("sortRanking") sortRanking!: MatSort;
      dsRanking!: MatTableDataSource<any>;
      colsRanking: string[] = ['posicion', 'materialesEscaneados', 'tiempo_real_picks', 'scan_errors', 'errores_calidad', 'dias_productivos', 'posiciones', 'puntaje'];

      //Cajas rechazadas por semaforo
      progressList: {porcentaje: number, periodo: string, cajas:number, cajas_rechazadas: number, color: string, color2: string}[] = [];
      fechaActual: Date = new Date();

      //Defectos detectados por calidad
      selectedDefecto: string | null = null;
      defectosCalidad=new Array<any>();
      defectosDataTable: {box_id: number, tipo_error: string, id_ext: string, consecutivo: number, estacion: number, nombre: string, cantidad: string}[] = [];

      @ViewChild("paginatorDefectos") paginatorDefectos!: MatPaginator;
      @ViewChild("sortDefectos") sortDefectos!: MatSort;
      dsDefectos!: MatTableDataSource<any>;
      colsDefectos: string[] = ['box_id', 'id_ext', 'consecutivo', 'estacion', 'nombre', 'cantidad', 'tipo_error'];

      //Cumplimiento de objetivos
      objetivosCampaign: {fecha: string}[] = [];
      periodosCampaign: {cajas: number, fechaObjetivo: string, total_encintadas: number}[] = [];

      //Cajas procesadas por linea
      boxesProcesadasLinea: {cajas_encintadas: number, line: number, porcentaje: number, cajas_x_linea: number, promedio_empaque: string, color1: string, color2: string}[] = [];

      constructor(
          private monitoringServ: MonitoringService,
          private matDialog: MatDialog,
          private cdr: ChangeDetectorRef,
          private overlay: Overlay
      ) {
        
      }

      ngOnInit(): void {
        this.getCampaignList();
      }

      //Obtener campaigns para el select
      getCampaignList() {
        this.monitoringServ.getCampaingsMonitoringList().subscribe(
          (result: any) => {
            this.campaignList = result;
            this.setCampaignData(this.campaignList[0]);
          },
          (err: any) => {
            console.log(err);
            this.isLoading = false;
            this.isLoadingGeneral = false;
            this.isLoadingPeriodos = false;
            this.isLoadingCajas = false;
            this.isLoadingArchivo = false;
            this.isLoadingPaqueteria = false;
            this.isLoadingTamanos = false;
            this.isLoadingRecolecciones = false;
            this.isLoadingCajasProcesadas = false;
            this.isLoadingCumplimiento = false;
            this.isLoadingDefectos = false;
            this.isLoadingCajasRechazadas = false;
            this.isLoadingPicksStation = false;
            this.isLoadingRanking = false;
            this.isLoadingCalidad = false;
          }
        );
      }

      setCampaignData (campaign:any) {
          this.isLoading = true;
          this.isLoadingGeneral = true;
          this.isLoadingPeriodos = true;
          this.isLoadingCajas = true;
          this.isLoadingArchivo = true;
          this.isLoadingPaqueteria = true;
          this.isLoadingTamanos = true;
          this.isLoadingRecolecciones = true;
          this.isLoadingCajasProcesadas = true;
          this.isLoadingCumplimiento = true;
          this.isLoadingDefectos = true;
          this.isLoadingCajasRechazadas = true;
          this.isLoadingPicksStation = true;
          this.isLoadingRanking = true;
          this.isLoadingCalidad = true;

          this.campaignSelected = campaign;
          this.selectedRec1 = 'cajas';
          this.selectedRec2 = 'periodos';
          this.getGeneralData(campaign)
          this.getPeriodos(campaign)
          this.getProgresoCajas(campaign)
          this.getProgresoArchivo(campaign)
          this.getProgresoPaqueteria(campaign)
          this.getProgresoTamanos(campaign)
          this.getRecoleccionesMon(campaign)
          this.getCajasProcesadas(campaign)
          this.getCumplimientoObjetivos(campaign)
          this.getDefectosCalidad(campaign)
          this.getCajasRechazadasMon(campaign)
          this.getPicksStation(campaign)
          this.getRankingPosiciones(campaign)
          this.getProgresoCalidad(campaign)
          //this.getData(campaign);
      }

      getGeneralData(campaign: any){

        this.monitoringServ.getGeneralData(campaign.id).subscribe(
          (result: any) => {
            
            //Encabezado
            this.compania = result.campaignData[0][0].clave;
     
            if(result.campaignData[0][0].fecha_inicio != null){
              const fechaOriginal1 = new Date(result.campaignData[0][0].fecha_inicio);
              const fechaAjustada1 = new Date(fechaOriginal1.getTime() + (6 * 60 * 60 * 1000)); // Ajusta según zona horaria
              this.fecha_inicio = fechaAjustada1.toISOString().split('T')[0];
            }
            else{
              this.fecha_inicio = '';
            }

            if(result.campaignData[0][0].fecha_fin != null){
              const fechaOriginal2 = new Date(result.campaignData[0][0].fecha_fin);
              const fechaAjustada2 = new Date(fechaOriginal2.getTime() + (6 * 60 * 60 * 1000)); // Ajusta según zona horaria
              this.fecha_fin = fechaAjustada2.toISOString().split('T')[0];
            }
            else{
              this.fecha_fin = '';
            }

            //Objetivo general
            this.total_cajas = result.boxes[0][0].cajas_por_encintar;
            this.duracion_campana = this.calcularDuracionCampana(this.fecha_inicio,this.fecha_fin);
            this.objetivo_diario = result.objetivoDiario[0][0]?.total_cajas || 0;
            this.hr_restantes = result.objetivoDiario[0][0]?.total_horas;
            this.total_cajas_encintadas = result.boxesTaped[0][0].cajas_encintadas;
            this.progress = (this.total_cajas_encintadas > 0 && this.objetivo_diario > 0) ? Math.round((this.total_cajas_encintadas / this.objetivo_diario) * 100) : 0;

            //Cards
            this.totalSKU = result.skus;
            this.bolsas = result.bags[0][0].bolsas;
            this.zonas = result.zones[0][0].zonas;
            this.totalPicks = result.picks;
            this.materialG = result.materialg;
            this.sucursales = result.sucursales[0][0].sucursales;

            this.isLoadingGeneral = false;

          },
          (err: any) => {
            console.log(err);
            this.isLoadingGeneral = false;
          }
        );

      }

      getPeriodos(campaign: any){

        this.monitoringServ.getPeriodos(campaign.id).subscribe(
          (result: any) => {
            
            //Periodos
            this.periodos = result.periodos[0];
            this.periodos = this.transformarPeriodos(this.periodos);
            this.isLoadingPeriodos = false;

          },
          (err: any) => {
            console.log(err);
            this.isLoadingPeriodos = false;
          }
        );

      }

      getProgresoCajas(campaign: any){

        this.monitoringServ.getProgresoCajas(campaign.id).subscribe(
          (result: any) => {
            
            //Progreso por cajas
            this.cerradas = result.arrCajas.cerradas;
            this.encintadas = result.arrCajas.encintadas;
            this.en_linea = result.arrCajas.en_linea;
            this.pendientes = result.arrCajas.pendientes;

            this.chartSeries = [this.pendientes, this.en_linea, this.cerradas, this.encintadas];
            this.dsCajas = new MatTableDataSource(result.progresoxcajas);
            this.progresoxcajas = result.progresoxcajas;

            setTimeout(() => {
              this.dsCajas.paginator = this.paginator;
              this.dsCajas.sort = this.sort;              
            });

            this.isLoadingCajas = false;

          },
          (err: any) => {
            console.log(err);
            this.isLoadingCajas = false;
          }
        );

      }

      getProgresoArchivo(campaign: any){

        this.monitoringServ.getProgresoArchivo(campaign.id).subscribe(
          (result: any) => {
            
            //Progreso por archivo
            let arrLabels2:string[] = [];
            let arrSeries2:ApexNonAxisChartSeries = [];

            result.arrArchivos.map( (item: any) => {
              arrLabels2.push(item.nombre)
              arrSeries2.push(item.total)
            });

            this.chartLabels2 = arrLabels2;
            this.chartSeries2 = arrSeries2;

            this.dsArchivo = new MatTableDataSource(result.progresoxarchivo[0]);
            this.progresoxarchivo = result.progresoxarchivo[0];

            setTimeout(() => {
              this.dsArchivo.paginator = this.paginatorArchivo;
              this.dsArchivo.sort = this.sortArchivo;
            });

            this.isLoadingArchivo = false;

          },
          (err: any) => {
            console.log(err);
            this.isLoadingArchivo = false;
          }
        );

      }

      getProgresoPaqueteria(campaign: any){

        this.monitoringServ.getProgresoPaqueteria(campaign.id).subscribe(
          (result: any) => {
            
           //Progreso por paqueteria
            this.progresoxpaqueteria = result.arrPaqueteria[0];
            this.dsPaqueteria = new MatTableDataSource(result.objPaqueteriaTable);

            setTimeout(() => {
              this.dsPaqueteria.paginator = this.paginatorPaqueteria;
              this.dsPaqueteria.sort = this.sortPaqueteria;
            });

            this.isLoadingPaqueteria = false;

          },
          (err: any) => {
            console.log(err);
            this.isLoadingPaqueteria = false;
          }
        );

      }

      getProgresoTamanos(campaign: any){

        this.monitoringServ.getProgresoTamanos(campaign.id).subscribe(
          (result: any) => {
            
           //Progreso por tamaños
            this.progresoxtamanos = result.progresoxtamano[0];
            this.tamanosDataTable = result.progresoxtamano[1];
            this.dsTamanos = new MatTableDataSource(result.progresoxtamano[1]);

            setTimeout(() => {
              this.dsTamanos.paginator = this.paginatorTamanos;
              this.dsTamanos.sort = this.sortTamanos;
            });

            this.isLoadingTamanos = false;

          },
          (err: any) => {
            console.log(err);
            this.isLoadingTamanos = false;
          }
        );

      }

      getRecoleccionesMon(campaign: any){

        this.monitoringServ.getRecolecciones(campaign.id).subscribe(
          (result: any) => {
            
           //Recolecciones
            this.recCerradas = result.recCerradas[0];
            this.recCerradas = this.processDataRecolecciones(this.recCerradas,1);
            this.arrayBoxIdsTotal = result.arrayBoxIdsTotal;

            this.recCerradasTarde = [];

            //Obtener los ids de las que no son de ese dia

              this.monitoringServ.getRecoleccionesTarde(this.selectedRec1,this.arrayBoxIdsTotal,campaign.id,this.selectedRec2).subscribe(
                (result: any) => {
                  this.recCerradasTarde = result.data;
                  this.recCerradasTarde = this.processDataRecolecciones(this.recCerradasTarde,2);
                },
                (err: any) => {
                  console.log(err);
                }
              );

            this.recPendientes = result.recPendientes[0];
            this.recPendientes = this.processDataRecolecciones(this.recPendientes,3);

            this.isLoadingRecolecciones = false;

          },
          (err: any) => {
            console.log(err);
            this.isLoadingRecolecciones = false;
          }
        );

      }

      getCajasProcesadas(campaign: any){

        this.monitoringServ.getCajasProcesadasPorLinea(campaign.id).subscribe(
          (result: any) => {
            
           //Cajas procesadas por linea
            this.boxesProcesadasLinea = result.boxesByLine[0];

            this.isLoadingCajasProcesadas = false;

          },
          (err: any) => {
            console.log(err);
            this.isLoadingCajasProcesadas = false;
          }
        );

      }

      getCumplimientoObjetivos(campaign: any){

        this.monitoringServ.getCumplimientoDeObjetivos(campaign.id).subscribe(
          (result: any) => {
            
           //Cumplimientos campaña
            this.objetivosCampaign = result.objetivosCampaign[0];
            this.periodosCampaign = result.cumplimiento[0];

            this.isLoadingCumplimiento = false;

          },
          (err: any) => {
            console.log(err);
            this.isLoadingCumplimiento = false;
          }
        );

      }

      getDefectosCalidad(campaign: any){

        this.monitoringServ.getDefectosCalidad(campaign.id).subscribe(
          (result: any) => {
            
           //Defectos Calidad
            this.defectosCalidad = result.defectosCalidad[0];
            this.defectosDataTable = result.defectosCalidad[1];
            this.dsDefectos = new MatTableDataSource(result.defectosCalidad[1]);

            setTimeout(() => { 
              this.dsDefectos.paginator = this.paginatorDefectos;
              this.dsDefectos.sort = this.sortDefectos;
            });

            this.isLoadingDefectos = false;

          },
          (err: any) => {
            console.log(err);
            this.isLoadingDefectos = false;
          }
        );

      }

      getCajasRechazadasMon(campaign: any){

        this.monitoringServ.getCajasRechazadas(campaign.id).subscribe(
          (result: any) => {
            
           //Cajas rechazadas por semaforo
            this.progressList = result.boxesRechazadas[0];
            this.fechaActual = new Date();
            this.isLoadingCajasRechazadas = false;
            

          },
          (err: any) => {
            console.log(err);
            this.isLoadingCajasRechazadas = false;
          }
        );

      }

      getPicksStation(campaign: any){

        this.monitoringServ.getPicksStation(campaign.id).subscribe(
          (result: any) => {
           this.dsPicksEstacion = new MatTableDataSource(result.picksStation);
           this.barChartData = {labels: [],datasets: []}

           setTimeout(() => { 
              this.dsPicksEstacion.paginator = this.paginatorPicksEstacion;
              this.dsPicksEstacion.sort = this.sortPicksEstacion;
            });

            //Para que ordene sobre el valor numerico, y no sobre el string que se muestra
            this.dsPicksEstacion.sortingDataAccessor = (item, property) => {
              switch (property) {
                case 'objTiempoCaja':
                  return item.objTiempoCaja;
                case 'objTiempoPick':
                  return item.objTiempoPick;
                case 'realTiempoCaja':
                  return item.realTiempoCaja;
                case 'realTiempoPick':
                  return item.realTiempoPick;
                default:
                  return item[property];
              }
            };

            this.isLoadingPicksStation = false;

          },
          (err: any) => {
            console.log(err);
            this.isLoadingPicksStation = false;
          }
        );

      }

      getRankingPosiciones(campaign: any){

        this.monitoringServ.getRankingPosiciones(campaign.id).subscribe(
          (result: any) => {
            
            this.dsRanking = new MatTableDataSource(result.rankingPosiciones);

           setTimeout(() => { 
                this.dsRanking.paginator = this.paginatorRanking;
                this.dsRanking.sort = this.sortRanking;
            });

            this.dsRanking.sortingDataAccessor = (item, property) => {
              switch (property) {
                case 'tiempo_real_picks':
                  return item.tiempo_real_picks;
                default:
                  return item[property];
              }
            };

            this.isLoadingRanking = false;

          },
          (err: any) => {
            console.log(err);
            this.isLoadingRanking = false;
          }
        );

      }

      getProgresoCalidad(campaign: any){

        this.monitoringServ.getProgresoCalidad(campaign.id).subscribe(
          (result: any) => {
            
            this.dsCalidad = new MatTableDataSource(result.progressCalidad);

            setTimeout(() => { 
              this.dsCalidad.paginator = this.paginatorCalidad;
              this.dsCalidad.sort = this.sortCalidad;
             
            });

            this.dsCalidad.sortingDataAccessor = (item, property) => {
              switch (property) {
                case 'tiempo_real_cajas':
                  return item.tiempo_real_cajas;
                case 'tiempo_real_picks':
                  return item.tiempo_real_picks;
                default:
                  return item[property];
              }
            };

            this.isLoadingCalidad = false;

          },
          (err: any) => {
            console.log(err);
            this.isLoadingCalidad = false;
          }
        );

      }

      calcularDuracionCampana(fecha1: any, fecha2: any) {
        if(fecha1 == '' || fecha2 == ''){
          return 0;
        }
        // Crear objetos Date y normalizar a UTC sin horas/minutos
        const inicio = new Date(fecha1);
        const fin = new Date(fecha2);
        
        const inicioUTC = Date.UTC(inicio.getFullYear(), inicio.getMonth(), inicio.getDate());
        const finUTC = Date.UTC(fin.getFullYear(), fin.getMonth(), fin.getDate());
        
        // Calcular diferencia en días
        const diferenciaMs = Math.abs(finUTC - inicioUTC);
        return Math.floor(diferenciaMs / (1000 * 60 * 60 * 24)) + 1;
      }

      convertirHoraFormato12h(hora24: any) {
        const [hora, minutos] = hora24.split(':');
        const horaNumerica = parseInt(hora);
        const periodo = horaNumerica >= 12 ? 'pm' : 'am';
        const hora12 = horaNumerica % 12 || 12;
        return `${hora12}:${minutos} ${periodo}`;
      }

      transformarPeriodos(periodos: any) {
        return periodos.map((periodo: any, index: any) => {

          let nuevoNombre = '';
          if((index + 1) == 1 || (index + 1) == 3){
             nuevoNombre = `${index + 1}er periodo`;
          }
          else if((index + 1) == 2){
            nuevoNombre = `${index + 1}do periodo`;
          }
          else if((index + 1) == 4 || (index + 1) == 5 || (index + 1) == 6){
            nuevoNombre = `${index + 1}to periodo`;
          }

          const nuevaHoraInicio = this.convertirHoraFormato12h(periodo.hora_inicio);
          const nuevaHoraFin = this.convertirHoraFormato12h(periodo.hora_fin);
          
          return {
            nombre: nuevoNombre,
            inicio: nuevaHoraInicio,
            fin: nuevaHoraFin,
            cajas: periodo.cajas
          };
        });
      }

      openDialogMaterialList(row:any) {
          this.matDialog.open(BoxMaterialsListComponent, {
            panelClass: ['dialogs-main'],
            data: {
              box : row
            },
            scrollStrategy: this.overlay.scrollStrategies.noop()
          })
      }

      filtrarTablaPorCaja(categoria: string) {

          if (this.selectedCategory === categoria) {
            // Deselecciona
            this.selectedCategory = null;
            this.dsCajas.data = this.progresoxcajas;
          }
          else {
            this.selectedCategory = categoria;
            if(categoria == "Cerradas"){categoria = "Cerrada"}
            if(categoria == "Pendientes"){categoria = "Pendiente"}
            if(categoria == "Encintadas"){categoria = "Encintada"}
            if(categoria == "En línea"){categoria = "En línea"}
  
            const filtrado = this.progresoxcajas.filter(item => item.status === categoria);
            this.dsCajas.data = filtrado;
          }

          setTimeout(() => {
            this.cdr.detectChanges();
          }, 0);

      }

      filtrarTablaPorArchivo(categoria: string) {

        if (this.selectedCategoryArchivo === categoria) {
          // Deselecciona
          this.selectedCategoryArchivo = null;
          this.dsArchivo.data = this.progresoxarchivo;
        }
        else {
          this.selectedCategoryArchivo = categoria;
          const filtrado = this.progresoxarchivo.filter(item => item.paqueteria === categoria);
          this.dsArchivo.data = filtrado;
        }

        setTimeout(() => {
          this.cdr.detectChanges();
        }, 0);
      }

      isImageAvailable(carrier: any): any {
        return this.validCarriers.includes(carrier);
      }

      imgFormat(value:string) {
        if(!value) return;
        return value = value.replace(/\s+/g, '').toLowerCase();
      }

      filterPaqueteria(paqueteria: any){

        if(paqueteria == 'Sin paquetería'){ paqueteria = null}

        if(this.selectedCarrier == paqueteria){
          this.filterCarrier = false;
          this.selectedCarrier = '';
          this.cdr.detectChanges();
        }
        else{
          this.selectedCarrier = paqueteria;
          this.monitoringServ.getPaqueteriaData(paqueteria,this.campaignSelected?.id ?? 0).subscribe(
            (result: any) => {

              this.filterCarrier = true;

              setTimeout(() => {
                this.dsPaqueteriaFiltro = new MatTableDataSource(result.data);
                this.dsPaqueteriaFiltro.paginator = this.paginatorPaqueteriaFiltro;
                this.dsPaqueteriaFiltro.sort = this.sortPaqueteriaFiltro;
                this.cdr.detectChanges();

                const tableElement = document.querySelector('table[mat-table]');
                if (tableElement) {
                  const event = new Event('mouseenter');
                  tableElement.dispatchEvent(event);
                }
              });

              
            }
          )
        }

      }


      filterTamanos(box_size: string){

        if(this.selectedTamano == box_size){
          this.selectedTamano = null;
          this.dsTamanos.data = this.tamanosDataTable;
        }
        else{
          this.selectedTamano = box_size;
          const filtrado = this.tamanosDataTable.filter(item => item.box_size === box_size);
          this.dsTamanos.data = filtrado;
        }

        setTimeout(() => {
          this.cdr.detectChanges();
        }, 0);
        
      }

      getRecolecciones() {

        this.monitoringServ.getRecoleccionesData(this.campaignSelected?.id ?? 0, this.selectedRec1, this.selectedRec2).subscribe(
          (result: any) => {
            
            this.recCerradas = result.data;
            this.recCerradas = this.recCerradas == undefined ? this.recCerradas : this.processDataRecolecciones(this.recCerradas,1);
            this.arrayBoxIdsTotal = result.arrayBoxIdsTotal;

            this.recPendientes = result.dataPendientes;
            this.recPendientes = this.recPendientes == undefined ? this.recPendientes : this.processDataRecolecciones(this.recPendientes,3);

            //if( this.total_recolectadas_dia > this.objetivo_recolectadas){

              this.monitoringServ.getRecoleccionesTarde(this.selectedRec1,this.arrayBoxIdsTotal,this.campaignSelected?.id ?? 0,this.selectedRec2).subscribe(
                (result: any) => {
                  this.recCerradasTarde = result.data;
                  this.recCerradasTarde = this.processDataRecolecciones(this.recCerradasTarde,2);
                },
                (err: any) => {
                  console.log(err);
                }
              );
            //}
          },
          (err: any) => {
            console.log(err);
          }
        );
      }

      processDataRecolecciones(objRecolecciones: any, tipoR:number){

        //tipo 1 = recolectadas a tiempo, 2 = recolectadas tarde

        return objRecolecciones.map((item: any, index: any) => {
            let nuevoNombre = '';
            let color = '';
            let pendientes: any;
            let hora_pendientes: any;
            let hora_recolectada: any;
            let ultima_encintada: any;
            let dias_retardo:number = 0;

            if(item.hora_inicio !== undefined){

              const nuevaHoraInicio = this.convertirHoraFormato12h(item.hora_inicio);
              //Para ponerle el nombre al periodo
              if(tipoR == 1){
                this.periodos.forEach(periodo => {
                  if(nuevaHoraInicio == periodo.inicio){
                    nuevoNombre = periodo.nombre
                  }
                })
              }

              //Pendientes O Recolectadas tarde
              else if(tipoR == 3 || tipoR == 2){
                if(item.periodos_p != ''){

                  const periodosArray = item.periodos_p.split(',');

                  periodosArray.forEach((periodo:any, index: number) => {

                    let nuevoNombre1 = '';

                    if((index + 1) == 1 || (index + 1) == 3){
                      nuevoNombre1 = `${index + 1}er periodo`;
                    }
                    else if((index + 1) == 2){
                      nuevoNombre1 = `${index + 1}do periodo`;
                    }
                    else if((index + 1) == 4 || (index + 1) == 5 || (index + 1) == 6){
                      nuevoNombre1 = `${index + 1}to periodo`;
                    }

                    if(item.hora_inicio == periodo){
                      nuevoNombre = nuevoNombre1;
                    }                                      
                  });
                }
              }

              for (let key in this.colorsRecolecciones) {
                if (nuevoNombre.includes(key)) {
                  color = this.colorsRecolecciones[key].color;
                }
              }
              

            }
            //Paara cuando se escoja ver por cajas cerradas
            else{
              nuevoNombre = '';
              //const keys = Object.keys(this.colorsRecolecciones);
              //const randomKey = keys[Math.floor(Math.random() * keys.length)];
              color = '#0091EA';
            }

            //Si estan recolectadas a tiempo entran aqui o pendientes de dias anteriores
            if(tipoR == 1 || tipoR == 3){
              ultima_encintada = this.convertirHoraFormato12h(item.ultima_encintada);
              if(item.fecha_recolectada != null){
                hora_recolectada = this.convertirHoraFormato12h(item.fecha_recolectada);
              }
              else{
                hora_recolectada = null;
              }

              //Pendientes
              if(item.total_encintadas > item.recolectadas){
                pendientes = item.total_encintadas - item.recolectadas + ' Cajas';
                hora_pendientes = ultima_encintada;
              }
              else{
                pendientes = 'Completado';
                hora_pendientes = hora_recolectada;
              }

              this.objetivo_recolectadas += item.recolectadas;
              this.total_recolectadas_dia = item.total_recolectadas_x_dia;
            }
            else{
              hora_recolectada = this.convertirHoraFormato12h(item.hora_salida);
              item.recolectadas = item.box_ids.split(',').length;
              dias_retardo = item.dias_retardo;
            }
          
          return {
            nombrePeriodo: nuevoNombre,
            ultima_encintada: ultima_encintada,
            tipo: item.tipo,
            total_encintadas: item.total_encintadas,
            fecha: item.fecha,
            color: color,
            dia: item.dia,
            recolectadas: item.recolectadas,
            hora_recolectada: hora_recolectada,
            pendientes: pendientes,
            hora_pendientes: hora_pendientes,
            dias_retardo: dias_retardo,
            documento: item.documento
          };
        });


      }

      updateChartData(type: number){
        let dataSet:any = [];
        this.selectedCajaPick = type;

        if(type == 1){
          dataSet = [
            {
              label: 'Real caja',
              data: this.dataRealCaja,
              backgroundColor: '#7080be',
              stack: 'Caja'
            },
            {
              label: 'Obj. caja',
              data: this.dataObjCaja,
              backgroundColor: '#d96b79',
              stack: 'Caja'
            },
            {
              label: 'Real pick',
              data: this.dataRealPick,
              backgroundColor: '#72cbe0',
              stack: 'Pick'
            },
            {
              label: 'Obj. pick',
              data: this.dataObjPick,
              backgroundColor: '#f8b24c',
              stack: 'Pick'
            }
          ]
        }
        else if(type == 2){
          dataSet = [
            {
              label: 'Real caja',
              data: this.dataRealCaja,
              backgroundColor: '#7080be',
              stack: 'Caja'
            },
            {
              label: 'Obj. caja',
              data: this.dataObjCaja,
              backgroundColor: '#d96b79',
              stack: 'Caja'
            }
          ]
        }
        else if(type == 3){
          dataSet = [
            {
              label: 'Real pick',
              data: this.dataRealPick,
              backgroundColor: '#72cbe0',
              stack: 'Pick'
            },
            {
              label: 'Obj. pick',
              data: this.dataObjPick,
              backgroundColor: '#f8b24c',
              stack: 'Pick'
            }
          ]
        }

        //Se pone el valor maximo para el eje Y
        let maxPick = Math.max(...this.dataRealPick) + Math.max(...this.dataObjPick);
        let maxCaja = Math.max(...this.dataRealCaja) + Math.max(...this.dataObjCaja);

        this.barChartOptions.scales.y.max = Math.ceil(Math.max(maxPick,maxCaja));

        this.barChartData = {
          labels: this.dataLabelsPicksCaja,
          datasets: dataSet
        };
      }

      toggleRowSelection(row: any) {
        const index = this.selectedRows.indexOf(row);

        if (index >= 0) {
          // Ya estaba seleccionada: deselecciona
          this.selectedRows.splice(index, 1);
        } else {
          if (this.selectedRows.length < 2) {
            // Selecciona hasta 2
            this.selectedRows.push(row);
          } else {
            this.selectedRows.shift();
            this.selectedRows.push(row);
          }
        }

        if(this.selectedRows.length > 1){
          this.dataRealCaja = [];
          this.dataObjCaja = [];
          this.dataRealPick = [];
          this.dataObjPick = [];
          this.dataLabelsPicksCaja = [];

          this.dataRealCaja.push(this.selectedRows[0].realTiempoCaja);
          this.dataRealCaja.push(this.selectedRows[1].realTiempoCaja);

          this.dataObjCaja.push(this.selectedRows[0].objTiempoCaja);
          this.dataObjCaja.push(this.selectedRows[1].objTiempoCaja);

          this.dataRealPick.push(this.selectedRows[0].realTiempoPick);
          this.dataRealPick.push(this.selectedRows[1].realTiempoPick);

          this.dataObjPick.push(this.selectedRows[0].objTiempoPick);
          this.dataObjPick.push(this.selectedRows[1].objTiempoPick);

          this.dataLabelsPicksCaja.push(this.selectedRows[0].estacion);
          this.dataLabelsPicksCaja.push(this.selectedRows[1].estacion);

          this.updateChartData(this.selectedCajaPick);
        }
        
      }

      isSelected(row: any): boolean {
        return this.selectedRows.includes(row);
      }

      getCajasRechazadas() {

        const yyyy = this.fechaActual.getFullYear();
        const mm = String(this.fechaActual.getMonth() + 1).padStart(2, '0');
        const dd = String(this.fechaActual.getDate()).padStart(2, '0');
        const fechaFormateada = `${yyyy}-${mm}-${dd}`;

        this.monitoringServ.getCajasRechazadasData(this.campaignSelected?.id ?? 0, fechaFormateada).subscribe(
          (result: any) => {
            
           this.progressList = result.data

          },
          (err: any) => {
            console.log(err);
          }
        );
      }

      filterCalidad(tipo_error: string){
        
        if(this.selectedDefecto == tipo_error){
          this.selectedDefecto = null;
          this.dsDefectos.data = this.defectosDataTable;
        }
        else{
          this.selectedDefecto = tipo_error;
          const filtrado = this.defectosDataTable.filter(item => item.tipo_error === tipo_error);
          this.dsDefectos.data = filtrado;
        }

        setTimeout(() => {
          this.cdr.detectChanges();
        }, 0);
        
      }
    
}
